import { createApp } from 'vue';
import PictToTiffConverter from '../Components/PictToTiffConverter.vue';

createApp(PictToTiffConverter).mount('#pict-to-tiff-converter');
